





























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import _ from "lodash";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: any[];

  handleSubmit() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要提交吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/saveGrounds", {
          stadium_id: this.stadiumId,
          grounds: this.grounds
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  // 上移
  handleUp(id: number, sn: number) {
    // 当前这个上移
    const idx: number = _.findIndex(this.grounds, o => o.id === id);
    _.set(this.grounds, [idx, "sn"], sn - 1);
    // 前一个后移
    _.set(this.grounds, [idx - 1, "sn"], sn);

    this.grounds = _.sortBy(this.grounds, o => o.sn);
  }

  // 下移
  handleDown(id: number, sn: number) {
    // 当前这个下移
    const idx: number = _.findIndex(this.grounds, o => o.id === id);
    _.set(this.grounds, [idx, "sn"], sn + 1);
    // 后一个上移
    _.set(this.grounds, [idx + 1, "sn"], sn);

    this.grounds = _.sortBy(this.grounds, o => o.sn);
  }

  handleDelete(sn: number, groundName: string) {
    const groundlength: number = this.grounds.length + 1;
    this.$confirm({
      title: "确认信息",
      content: `确定删除"${groundName}"吗？删除后将默认新增"${groundlength}号片场"`,
      onOk: async () => {
        // 移除当前的
        _.remove(this.grounds, o => o.sn === sn);
        // 最后加一位
        this.grounds.push({
          id: "",
          stadium_id: this.stadiumId,
          name: `${groundlength}号片场`,
          status: 1,
          stage: 0,
          sn: 0,
          description: ""
        });
        // 重排sn
        for (const idx in this.grounds) {
          _.set(this.grounds, [idx, "sn"], Number(idx) + 1);
        }
      }
    });
  }

  async mounted() {}
}
